// extracted by mini-css-extract-plugin
export default {"line":"SDGYqQh_kLad78b_RiOJ","row":"oQF4BebkVtIk4fKsGr2m","col":"X_W2ACXUpqqR6p42hZK_","options":"vePNpd0625oTdXBRwSvn","placeHolderShimmer":"tIh3zGVcmnyvrX23KwBr"};